<template>
    <div>
        <b-modal :id="id" size="none">
            <template v-slot:modal-header="{ close }">
                <h3 class="w-100 text-center">{{ title }}
                    <button-open-help-modal v-bind:helpName="helpName" :inExtraDiv="false" :color="'black'"/>
                </h3>
                <button type="button" class="close" @click="close()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">{{ __("close") }}</span>
                </button>
            </template>
            <template v-slot:default>
                <aging-ranges-form
                    formId="aging_ranges_form"
                    :currency="currency"
                    :date="date"
                    :agingRange="agingRange"
                    @closeModal="closeModal()"
                />
            </template>
            <template v-slot:modal-footer>
                <button
                    type="button"
                    class="btn btn-white"
                    @click="closeModal()"
                >
                    {{ __("close") }}
                </button>
                <button
                    type="submit"
                    form="aging_ranges_form"
                    class="btn btn-primary"
                >
                    {{ __("apply") }}
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import AgingRangesForm from "./../forms/AgingRangesForm/AgingRangesForm";
import ButtonOpenHelpModal from '../help/ButtonOpenHelpModal.vue';
import HelpModal from '../help/HelpModal.vue';

export default {
    name: "modal-aging-ranges",
    components: {
        AgingRangesForm,
        ButtonOpenHelpModal,
        HelpModal
    },
    data: () => ({}),
    props: {
        id: {
            type: String,
            default: "modal"
        },
        title: String,
        currency: {
            default: null
        },
        date: {
            default: null
        },
        agingRange: {
            type: Object
        },
        helpName : {
            type: String,
            default: ""
        }
    },
    methods: {
        openModal() {
            this.$bvModal.show(this.id);
            setTimeout(() => {
                $('.modal-dialog').draggable({
                    handle: ".modal-header"

                });
            }, 1000)
        },
        closeModal() {
            this.$bvModal.hide(this.id);
        },
        apply() {
            this.$emit("apply");
        }
    }
};
</script>
